export default __webpack_public_path__ + "static/media/artistLogo3.3fdff12f.png";